"use client"

import { Icons } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Utils } from "@/lib/utils"
import { signIn } from "next-auth/react"
import { useTranslations } from "next-intl"
import Link from "next/link"
import { useEffect, useState } from "react"

export default function SignInForm() {
      const [email, setEmail] = useState("")
      const [isLoading, setIsLoading] = useState<boolean>(false)
      const t = useTranslations('signin')

      useEffect(() => {
            // Load reCAPTCHA script
            const loadRecaptcha = () => {
                  const script = document.createElement('script')
                  script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`
                  script.async = true
                  document.body.appendChild(script)
            }
            loadRecaptcha()
      }, [])

      const handleSubmit = async (e: React.FormEvent) => {
            e.preventDefault()
            setIsLoading(true)
            try {
                  debugger;
                  // Execute reCAPTCHA
                  const recaptchaToken = await (window as any).grecaptcha.execute(
                        process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY,
                        { action: 'signin' }
                  )

                  await Utils.http.fetchData('/api/auth/verify', 'POST', {
                        email,
                        token: recaptchaToken,
                  }).then(async () => {
                        return await signIn("email", { email, callbackUrl: "/" });
                  });

            } catch (error) {
                  console.error(error)
            } finally {
                  setIsLoading(false)
            }
      }

      return (
            <div className="space-y-6">
                  <div className="space-y-2 text-center flex flex-col items-center">

                        <h1 className="text-4xl font-bold">{t('title')}</h1>
                        <p className="text-muted-foreground">
                              {t('subtitle')}
                        </p>
                  </div>

                  <div className="space-y-4">
                        <Button
                              size="lg"
                              variant="outline"
                              className="w-full"
                              onClick={() => signIn("google", { callbackUrl: "/" })}
                              disabled={isLoading}
                        >
                              <Icons.google className="mr-2 h-4 w-4" />
                              {t('continue_with_google')}
                        </Button>

                        {/* <Button
                              size="lg"
                              variant="outline"
                              className="w-full"
                              onClick={() => signIn("microsoft", { callbackUrl: "/" })}
                              disabled={isLoading}
                        >
                              {isLoading ? (
                                    <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                              ) : (
                                    <Icons.microsoft className="mr-2 h-4 w-4" />
                              )}
                              {t('continue_with_microsoft')}
                        </Button> */}

                        <div className="relative">
                              <div className="absolute inset-0 flex items-center">
                                    <span className="w-full border-t" />
                              </div>
                              <div className="relative flex justify-center text-xs uppercase">
                                    <span className="bg-background px-2 text-muted-foreground">
                                          {t('or_continue_with')}
                                    </span>
                              </div>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-4">
                              <Input
                                    type="email"
                                    placeholder={t('email_placeholder')}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={isLoading}
                              />
                              <Button size="lg" type="submit" className="w-full" disabled={isLoading}>
                                    {isLoading && (
                                          <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                                    )}
                                    {t('continue_with_email')}
                              </Button>
                        </form>

                        <span className="text-muted-foreground text-sm text-center">
                              {t('by_clicking_continue_you_agree_to_our')}&nbsp;
                              <Link href="/legal/terms-of-use" className="text-primary">
                                    {t('terms_of_service')}
                              </Link>
                              &nbsp;{t('and')}&nbsp;
                              <Link href="/legal/privacy-policy" className="text-primary">
                                    {t('privacy_policy')}
                              </Link>
                        </span>

                        {/* <Separator className="my-4" />
                        <div className="flex flex-col gap-2">
                              <span className="text-muted-foreground text-sm text-center">
                                    {t('dont_have_account')}&nbsp;
                                    <Link href="/signup" className="text-primary">
                                          {t('signup')}
                                    </Link>
                              </span>

                              <span className="text-muted-foreground text-sm text-center">
                                    {t('forgot_password')}&nbsp;
                                    <Link href="/reset-password" className="text-primary">
                                          {t('reset_password')}
                                    </Link>
                              </span>
                        </div> */}
                  </div>
            </div>
      )
} 